import mitt from 'mitt'

export const eventEmitter = mitt()
export const useEventBus = () => ({ eventEmitterTs: eventEmitter })
